var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "60%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入名称",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "应用包名", prop: "packageName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入应用包名（可选）",
                      maxlength: "99",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.packageName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "packageName", $$v)
                      },
                      expression: "form.packageName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "打开方式", prop: "openMode", required: "" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择打开方式" },
                      model: {
                        value: _vm.form.openMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "openMode", $$v)
                        },
                        expression: "form.openMode",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "应用首页", value: 1 },
                      }),
                      _c("el-option", {
                        attrs: { label: "Activity 方式", value: 2 },
                      }),
                      _c("el-option", {
                        attrs: { label: "Action 方式", value: 3 },
                      }),
                      _c("el-option", {
                        attrs: { label: "URLScheme 方式", value: 4 },
                      }),
                      _c("el-option", {
                        attrs: { label: "Broadcast 方式", value: 5 },
                      }),
                      _c("el-option", {
                        attrs: { label: "Service 服务方式", value: 6 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "打开地址", prop: "openUrl", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入打开地址",
                      maxlength: "999",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.openUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "openUrl", $$v)
                      },
                      expression: "form.openUrl",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "打开参数" } }, [
                _c(
                  "div",
                  { staticClass: "params-container" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.addParam },
                      },
                      [_vm._v("添加参数")]
                    ),
                    _vm.form.openParam.length > 0
                      ? _c(
                          "div",
                          { staticClass: "params-list" },
                          _vm._l(_vm.form.openParam, function (param, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "param-item" },
                              [
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-right": "10px",
                                  },
                                  attrs: { placeholder: "参数名" },
                                  model: {
                                    value: param.key,
                                    callback: function ($$v) {
                                      _vm.$set(param, "key", $$v)
                                    },
                                    expression: "param.key",
                                  },
                                }),
                                _c("el-input", {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-right": "10px",
                                  },
                                  attrs: { placeholder: "参数值" },
                                  model: {
                                    value: param.value,
                                    callback: function ($$v) {
                                      _vm.$set(param, "value", $$v)
                                    },
                                    expression: "param.value",
                                  },
                                }),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "danger", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeParam(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                删除\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("应用其他信息"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用ID" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入应用ID（可选）" },
                            model: {
                              value: _vm.form.appId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appId", $$v)
                              },
                              expression: "form.appId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用名称" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入应用名称（可选）" },
                            model: {
                              value: _vm.form.appName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appName", $$v)
                              },
                              expression: "form.appName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Appkey" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入Appkey（可选）" },
                            model: {
                              value: _vm.form.appKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appKey", $$v)
                              },
                              expression: "form.appKey",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "应用版本号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入应用版本号（可选）" },
                            model: {
                              value: _vm.form.appVer,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appVer", $$v)
                              },
                              expression: "form.appVer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入备注（可选）",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }